__turbopack_context__.v({
  "attributeCard": "AvatarDetail-module__FWjDOa__attributeCard",
  "attributeIcon": "AvatarDetail-module__FWjDOa__attributeIcon",
  "attributeLabel": "AvatarDetail-module__FWjDOa__attributeLabel",
  "attributeValue": "AvatarDetail-module__FWjDOa__attributeValue",
  "attributesGrid": "AvatarDetail-module__FWjDOa__attributesGrid",
  "avatarPlaceholder": "AvatarDetail-module__FWjDOa__avatarPlaceholder",
  "container": "AvatarDetail-module__FWjDOa__container",
  "costItem": "AvatarDetail-module__FWjDOa__costItem",
  "costLabel": "AvatarDetail-module__FWjDOa__costLabel",
  "costsGrid": "AvatarDetail-module__FWjDOa__costsGrid",
  "ctaContainer": "AvatarDetail-module__FWjDOa__ctaContainer",
  "dotList": "AvatarDetail-module__FWjDOa__dotList",
  "dotListGreen": "AvatarDetail-module__FWjDOa__dotListGreen",
  "dotListRed": "AvatarDetail-module__FWjDOa__dotListRed",
  "genericPlaceholder": "AvatarDetail-module__FWjDOa__genericPlaceholder",
  "genericRow": "AvatarDetail-module__FWjDOa__genericRow",
  "header": "AvatarDetail-module__FWjDOa__header",
  "headerGenderAge": "AvatarDetail-module__FWjDOa__headerGenderAge",
  "headerLeft": "AvatarDetail-module__FWjDOa__headerLeft",
  "headerMeta": "AvatarDetail-module__FWjDOa__headerMeta",
  "headerName": "AvatarDetail-module__FWjDOa__headerName",
  "headerRole": "AvatarDetail-module__FWjDOa__headerRole",
  "headerSummary": "AvatarDetail-module__FWjDOa__headerSummary",
  "levelBadge": "AvatarDetail-module__FWjDOa__levelBadge",
  "levelHigh": "AvatarDetail-module__FWjDOa__levelHigh",
  "levelLow": "AvatarDetail-module__FWjDOa__levelLow",
  "levelMedium": "AvatarDetail-module__FWjDOa__levelMedium",
  "loaderContainer": "AvatarDetail-module__FWjDOa__loaderContainer",
  "scoreCardWrapper": "AvatarDetail-module__FWjDOa__scoreCardWrapper",
  "scoreHeader": "AvatarDetail-module__FWjDOa__scoreHeader",
  "scoreHeaderTop": "AvatarDetail-module__FWjDOa__scoreHeaderTop",
  "scoreInfo": "AvatarDetail-module__FWjDOa__scoreInfo",
  "scoreItem": "AvatarDetail-module__FWjDOa__scoreItem",
  "scoreItemTop": "AvatarDetail-module__FWjDOa__scoreItemTop",
  "scoreMax": "AvatarDetail-module__FWjDOa__scoreMax",
  "scoreTitle": "AvatarDetail-module__FWjDOa__scoreTitle",
  "scoreValue": "AvatarDetail-module__FWjDOa__scoreValue",
  "scoreValueContainer": "AvatarDetail-module__FWjDOa__scoreValueContainer",
  "scoresGrid": "AvatarDetail-module__FWjDOa__scoresGrid",
  "sourcesBox": "AvatarDetail-module__FWjDOa__sourcesBox",
  "sourcesHeader": "AvatarDetail-module__FWjDOa__sourcesHeader",
  "sourcesTitle": "AvatarDetail-module__FWjDOa__sourcesTitle",
  "tabContent": "AvatarDetail-module__FWjDOa__tabContent",
  "tag": "AvatarDetail-module__FWjDOa__tag",
  "tagEmotional": "AvatarDetail-module__FWjDOa__tagEmotional",
  "tagsList": "AvatarDetail-module__FWjDOa__tagsList",
  "textBlue": "AvatarDetail-module__FWjDOa__textBlue",
  "textGreen": "AvatarDetail-module__FWjDOa__textGreen",
  "textRed": "AvatarDetail-module__FWjDOa__textRed",
  "textSectionsGrid": "AvatarDetail-module__FWjDOa__textSectionsGrid",
  "twoColGrid": "AvatarDetail-module__FWjDOa__twoColGrid",
});
